import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from '../../../../components/Box';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { GetGTipListResponseData } from '../../../../models/response/gTip/GetGTipListResponseData';
import { GetLandOrderByIdResponseOrderDetail } from '../../../../models/response/landOrder/GetLandOrderByIdResponse';
import { storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { ConstantService } from '../../../../services/ConstantService';
import { GTipService } from '../../../../services/GTipService';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';

interface Props {
    detailsRef: any
    orderDetails: GetLandOrderByIdResponseOrderDetail[]
    setOrderDetails: React.Dispatch<React.SetStateAction<GetLandOrderByIdResponseOrderDetail[]>>
}

const OrderDetails = ({
    detailsRef,
    orderDetails,
    setOrderDetails,
}: Props) => {
    const dispatch = useDispatch();
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [quantity, setQuantity] = useState<string | undefined>(undefined);
    const [selectedGTip, setSelectedGTip] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [product, setProduct] = useState<string | undefined>(undefined);
    const [width, setWidth] = useState<string | undefined>(undefined);
    const [length, setLength] = useState<string | undefined>(undefined);
    const [height, setHeight] = useState<string | undefined>(undefined);
    const [weight, setWeight] = useState<string | undefined>(undefined);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [orderDetailId, setOrderDetailId] = useState('');
    const [_volume, setVolume] = useState<string | undefined>(undefined);
    const [_desi, setDesi] = useState<string | undefined>(undefined);
    const [_priceWeight, setPriceWeight] = useState<string | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);

    const setUpdateItem = () => {
        var o = orderDetails.filter(x => x.isSelected)[0];

        setOrderDetailId(o.orderDetailId);
        setSelectedPotType(o.potTypeId ? { label: o.potTypeName + '', value: o.potTypeId } : undefined);
        setQuantity(o.quantity);
        setSelectedGTip(o.gTipId ? { label: o.gTipName + '', value: o.gTipId } : undefined);
        setProduct(o.product);
        setWidth(o.width);
        setLength(o.length);
        setHeight(o.height);
        setVolume(o.volume);
        setDesi(o.desi);
        setWeight(o.weight);
        setPriceWeight(o.priceWeight);
        setSelectedCurrencyType(o.currencyTypeId ? { label: o.currencyTypeName + '', value: o.currencyTypeId } : undefined);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setOrderDetailId('');
        setSelectedPotType(undefined);
        setQuantity('');
        setSelectedGTip(undefined);
        setProduct('');
        setWidth('');
        setLength('');
        setHeight('');
        setVolume('');
        setDesi('');
        setWeight('');
        setPriceWeight('');
        setSelectedCurrencyType(undefined);
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = detailsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const deleteItems = () => {
        setOrderDetails(orderDetails.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = orderDetails.length == orderDetails.filter(x => x.isSelected).length;

        setOrderDetails(orderDetails.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setOrderDetails(orderDetails.map(function (x) {
            if (x.orderDetailId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const saveItem = () => {
        if (Helpers.isEmpty(orderDetailId)) {
            var o: GetLandOrderByIdResponseOrderDetail = {
                orderDetailId: Helpers.generateUUID(),
                isSelected: false,
                currencyTypeId: selectedCurrencyType?.value,
                currencyTypeName: selectedCurrencyType?.label,
                desi: (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) / 3000) : undefined)?.toFixed(2),
                gTipId: selectedGTip?.value,
                gTipName: selectedGTip?.label,
                height: height?.toString(),
                length: length?.toString(),
                potTypeId: selectedPotType?.value,
                potTypeName: selectedPotType?.label,
                priceWeight: (Math.max(...[
                    // hacim
                    (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) && !Helpers.isEmpty(quantity) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) * parseFloat(quantity + ''.replace(".", ",")) / 1000000) : undefined),
                    // desi
                    (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) / 3000) : undefined),
                    // ağırlık
                    (!Helpers.isEmpty(weight) ? parseFloat(weight + ''.replace(".", ",")) : undefined)
                ].filter((item): item is number => !!item))).toFixed(2),
                product: product,
                quantity: quantity?.toString(),
                volume: (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) && !Helpers.isEmpty(quantity) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) * parseFloat(quantity + ''.replace(".", ",")) / 1000000) : undefined)?.toFixed(2),
                weight: weight?.toString(),
                width: width?.toString()
            }

            setOrderDetails([...orderDetails, o])
        }
        else {
            setOrderDetails(orderDetails.map(function (x) {
                if (x.orderDetailId == orderDetailId) {
                    x.isSelected = false;
                    x.currencyTypeId = selectedCurrencyType?.value;
                    x.currencyTypeName = selectedCurrencyType?.label;
                    x.desi = (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) / 3000) : undefined)?.toFixed(2);
                    x.gTipId = selectedGTip?.value;
                    x.gTipName = selectedGTip?.label;
                    x.height = height?.toString();
                    x.length = length?.toString();
                    x.potTypeId = selectedPotType?.value;
                    x.potTypeName = selectedPotType?.label;
                    x.priceWeight = (Math.max(...[
                        // hacim
                        (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) && !Helpers.isEmpty(quantity) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) * parseFloat(quantity + ''.replace(".", ",")) / 1000000) : undefined),
                        // desi
                        (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) / 3000) : undefined),
                        // ağırlık
                        (!Helpers.isEmpty(weight) ? parseFloat(weight + ''.replace(".", ",")) : undefined)
                    ].filter((item): item is number => !!item))).toFixed(2);
                    x.product = product;
                    x.quantity = quantity?.toString();
                    x.volume = (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) && !Helpers.isEmpty(quantity) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) * parseFloat(quantity + ''.replace(".", ",")) / 1000000) : undefined)?.toFixed(2);
                    x.weight = weight?.toString();
                    x.width = width?.toString();
                }

                return x;
            }))
        }

        setOrderDetailId('');
        setSelectedPotType(undefined);
        setQuantity('');
        setSelectedGTip(undefined);
        setProduct('');
        setWidth('');
        setLength('');
        setHeight('');
        setVolume('');
        setDesi('');
        setWeight('');
        setPriceWeight('');
        setSelectedCurrencyType(undefined);
        setIsOpen(false);
        scrollTo();
    }

    return (
        <div className='containerPart' ref={detailsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Sipariş Detay Bilgileri</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Kap Cinsi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedPotType}
                                            onChange={setSelectedPotType}
                                            insertable={{
                                                onSubmit: { code: 'POT_TYPE' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('POT_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Miktar</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={quantity} onChange={(e) => setQuantity(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">GTip No</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedGTip}
                                            onChange={(selectedValue) => {
                                                if (selectedValue) {
                                                    while (selectedValue.label.startsWith('-'))
                                                        selectedValue.label = selectedValue.label.slice(1);
                                                }

                                                if (selectedValue)
                                                    setProduct(selectedValue?.additionalValue1);
                                                else
                                                    setProduct('');

                                                setSelectedGTip(selectedValue);
                                            }}
                                            onMenuOpen={(searchTerm) => GTipService.getGTipList(0, 100, searchTerm)}
                                            labelName='gTip1'
                                            label2Name='gTipDesc'
                                            valueName='gTipId'
                                            additionalValue1Name='gTipDesc'
                                            isPaging
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ürün</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={product} onChange={(e) => setProduct(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">En (cm)</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={width} onChange={(e) => setWidth(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Boy (cm)</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={length} onChange={(e) => setLength(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Yükseklik (cm)</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={height} onChange={(e) => setHeight(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hacim (m<sup>3</sup>)</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) && !Helpers.isEmpty(quantity) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) * parseFloat(quantity + ''.replace(".", ",")) / 1000000).toFixed(2) : ''} onChange={(e) => setVolume(e.target.value)} type="number" className="form-control form-control-solid" disabled />
                                    </div>


                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Desi (m<sup>3</sup>)</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) / 3000).toFixed(2) : ''} onChange={(e) => setDesi(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ağırlık (kg)</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={weight} onChange={(e) => setWeight(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ücret Ağırlığı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={Math.max(...[
                                            // hacim
                                            (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) && !Helpers.isEmpty(quantity) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) * parseFloat(quantity + ''.replace(".", ",")) / 1000000) : undefined),
                                            // desi
                                            (!Helpers.isEmpty(width) && !Helpers.isEmpty(height) && !Helpers.isEmpty(length) ? (parseFloat(width + ''.replace(".", ",")) * parseFloat(height + ''.replace(".", ",")) * parseFloat(length + ''.replace(".", ",")) / 3000) : undefined),
                                            // ağırlık
                                            (!Helpers.isEmpty(weight) ? parseFloat(weight + ''.replace(".", ",")) : undefined)
                                        ].filter((item): item is number => !!item)).toFixed(2)} onChange={(e) => setPriceWeight(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Döviz Cinsi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCurrencyType}
                                            onChange={setSelectedCurrencyType}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                                            labelName='additionalValue1'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={orderDetails.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={orderDetails.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={orderDetails.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={orderDetails.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={orderDetails.filter(x => x.isSelected).length > 0 && orderDetails.filter(x => x.isSelected).length == orderDetails.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Kap Cinsi</th>
                                            <th>Miktar</th>
                                            <th>GTip No</th>
                                            <th>Ürün</th>
                                            <th>En (cm)</th>
                                            <th>Boy (cm)</th>
                                            <th>Yükseklik (cm)</th>
                                            <th>Hacim (m3)</th>
                                            <th>Desi (m3)</th>
                                            <th>Ağırlık (kg)</th>
                                            <th>Ücret Ağırlığı</th>
                                            <th>Döviz Cinsi</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            orderDetails.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            orderDetails.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.orderDetailId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.potTypeName}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.quantity)}</td>
                                                    <td>{item.gTipName}</td>
                                                    <td>{item.product}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.width)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.length)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.height)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.volume)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.desi)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.weight)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.priceWeight)}</td>
                                                    <td>{item.currencyTypeName}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default OrderDetails;